<template>
  <base-detail :title="'Chicken Starters'">
    <ul>
      <li class="menuList" v-for="item in chickenStarters" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    chickenStarters() {
      const dataList = data.filter(
        (row) => row.type === "chicken" && row.mealType === "starters"
      );
      return dataList;
    },
  },
};
</script>
